import type { FontWeights } from '../index';

export const fontWeights: FontWeights = {
  thin: 300,
  normal: 400,
  bold: 'bold',
  bolder: 'bolder',
};
